import {
  BRDS_SIZE as moleculeNotificationBorderRadiusSize,
  VARIATIONS as moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'

const BASE_CLASS = 'mt-NotificationsAdFavorite'

const NOTIFICATIONS = {
  EMPTY: 'EMPTY',
  SUCCESS: 'SUCCESS',
  SUCCESS_DELETE: 'SUCCESS_DELETE',
  ERROR: 'ERROR',
  ERROR_DELETE: 'ERROR_DELETE'
}

const commonNotificationProps = {
  position: 'relative',
  roundedCorners: moleculeNotificationBorderRadiusSize.medium,
  show: true,
  showCloseButton: false,
  variation: moleculeNotificationVariations.negative
}

const NOTIFICATIONS_PROPS = {
  [NOTIFICATIONS.ERROR]: {
    ...commonNotificationProps,
    type: 'warning'
  },
  [NOTIFICATIONS.SUCCESS]: {
    ...commonNotificationProps,
    type: 'success'
  },
  [NOTIFICATIONS.SUCCESS_DELETE]: {
    ...commonNotificationProps,
    type: 'success'
  },
  [NOTIFICATIONS.ERROR_DELETE]: {
    ...commonNotificationProps,
    type: 'warning'
  }
}

export {BASE_CLASS, NOTIFICATIONS, NOTIFICATIONS_PROPS}
